<div class="app-header" fxLayout="row" fxLayoutAlign="space-between end" fxHide.gt-md="true" fxShow="true">
	<div class="logo-wrp-sm">
		<a routerLink="/">
			<img [ngClass]="order?.network" [src]="shop?.networkLogo" [alt]="shop?.networkName">
		</a>
	</div>
<!--	<div class="header-buttons-wrp">-->
<!--		<button type="button" class="button button-s blue" routerLink="/auth/login" *ngIf="!customer"> Login</button>-->
<!--		<button type="button" class="button button-s blue" *ngIf="customer" routerLink="/my-account/order-history">-->
<!--			<i class="fa-solid fa-user mr-4x"></i>-->
<!--			My Account-->
<!--		</button>-->
<!--	</div>-->
</div>

<div class="app-header" fxLayout="row" fxLayoutAlign.lt-lg="center end" fxLayoutAlign="space-between end" style="overflow: hidden">

	<div class="logo-wrp" fxShow.lg="true" fxHide.lt-lg="true" [ngClass]="networkClass">
		<a routerLink="/">
			<img [ngClass]="order?.network" [src]="shop?.networkLogo" [alt]="shop?.networkName">
		</a>
	</div>
	<div *ngIf="elementShow && settings && settings.showHeaderSteps" class="nav-step-wrp">
		<nav-steps [shop]="networkClass"></nav-steps>
	</div>
	<div class="header-buttons-wrp" fxShow.lg="true" fxHide.lt-lg="true">
<!--		<button type="button" class="button button-m blue" routerLink="/auth/login" *ngIf="!customer"> Login</button>-->
<!--		<button type="button" class="button button-m blue" *ngIf="customer" routerLink="/my-account/order-history">-->
<!--			<i class="fa-solid fa-user mr-4x"></i>-->
<!--      My Account-->
<!--		</button>-->
	</div>
</div>
